import { createContext } from 'react';

const TarificationFormContext = createContext({
  disabled: false,
});

export default TarificationFormContext;
